import React from "react";

import { CaretRightIcon } from "@phosphor-icons/react";
import { ColorIcon } from "~/sdks/LocalContent/components/ColorIcon";

import * as styles from "./styles";

export type ItemButtonProps = {
  text: string;
  isDisabled?: boolean;
  isCollapsed?: boolean;
  isActive?: boolean;
  icon: {
    element: React.ReactElement;
    backgroundColor?: string;
    fillColor?: string;
  };
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

export function ItemButton({
  text,
  isDisabled,
  isCollapsed = false,
  isActive = false,
  icon: { element: Icon, backgroundColor = "gray", fillColor = "black" },
  onClick,
  ...rest
}: ItemButtonProps) {
  return (
    <button
      className={styles.container}
      disabled={isDisabled}
      aria-label={text}
      onClick={onClick}
      data-background-color={backgroundColor}
      data-fill-color={fillColor}
      data-is-collapsed={isCollapsed}
      data-is-active={isActive}
      style={
        {
          "--item-button-background": backgroundColor,
          "--item-button-fill": fillColor,
        } as React.CSSProperties
      }
      {...rest}
    >
      <ColorIcon
        element={Icon}
        backgroundColor={backgroundColor}
        fillColor={fillColor}
      />
      <span className={styles.text}>{text}</span>
      <CaretRightIcon
        className={styles.arrow}
        weight="bold"
        size={12}
        aria-hidden="true"
      />
    </button>
  );
}
